import { render, staticRenderFns } from "./AiCasePageLayout.vue?vue&type=template&id=ce4fe6ca"
import script from "./AiCasePageLayout.vue?vue&type=script&lang=js"
export * from "./AiCasePageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports